import { Box, CircularProgress, Modal } from "@mui/material";
import { useState } from "react";
import Styles from './style.module.css';
// import { setUserData } from "../redux/userSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const PendingModal = ({ closeModal, open, desc, data }) => {
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch()
  const nav = useNavigate()
  const [isLoading, setIsLoading] = useState(false)

  const Data = data
  const styles = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "white",
    border: "none",
    padding: "27px 0px 0px",
    height: "fit-content",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: '300px',
    borderRadius: '7px',
    "&:focus": {
      outline: "none",
    },
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={styles}>
        <div
          className={Styles.entryView}
          style={{
            paddingLeft: 20,
            paddingRight: 20,
            flexDirection: "column",
          }}
        >
          <div className={Styles.headingText} style={{ textAlign: "center", color: "black" }}>
            Your request is pending
          </div>

          <div className={Styles.lineStyle} style={{ width: "100%" }} />
          Your Account is In Under Verification process , kindly Wait For The Team To Contact You.

        </div>
        <button onClick={() => nav("/")} style={{ marginTop: "10px", color: "#1D83F8", padding: "10px", fontWeight: "700", cursor: "pointer" }}>OK</button>
      </Box>
    </Modal>
  );
};

export default PendingModal;
